import { cva } from '@/styled-system/css';

export const upsellBodyRecipe = cva({
  base: {
    'marginBlockStart': 'none',

    '& > [data-c11n-component="Text"]': {
      color: 'inherit',
      textStyle: 'body',
    },
    '& > [data-c11n-component="Paragraph"]': {
      color: 'inherit',
      textStyle: 'body',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.neutral',
      },
      soft: {
        color: 'text.neutral',
      },
      hero: {
        color: 'Upsell.Body.hero.text',
      },
      impact: {
        color: 'text.onImpact.neutral',
      },
    },
  },
});
